<template>
  <div class="mb-16 font-normal">
    <h2 class="custom-title custom-color-gray font-medium mb-4">
      {{ $t('message.abm.folders.settings.AiDocument.question') }}
    </h2>
    <p class="custom-legend text-zt-dark-300 mb-4">
      {{ $t('message.abm.folders.settings.AiDocument.description') }}
    </p>
    <div class="w-full radio-group">
      <zt-radio-button
          :value="'false'"
          v-model="selected"
          name="visible"
          @change="update"
          data-vs-radio-button="radioAiDocument"
      >
        <span class="custom-label">{{ $t('message.abm.folders.settings.AiDocument.option.label') }}</span>
      </zt-radio-button>
      <span class="radio-legend block text-zt-dark-300">
        {{ $t('message.abm.folders.settings.AiDocument.option.legend') }}
      </span>
    </div>
    <div class="w-full">
      <zt-radio-button
          :value="'true'"
          v-model="selected"
          name="visible"
          @change="update"
          data-vs-radio-button="radioAiDocument"
      >
        <span class="custom-label"> {{ $t('message.abm.folders.settings.AiDocument.option1.label') }}</span>
      </zt-radio-button>
      <span class="radio-legend block text-zt-dark-300">
         {{ $t('message.abm.folders.settings.AiDocument.option1.legend') }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "SubFolderDocumentAi",
  inject:['stateFolder', 'setSubFolderParams'],
  data() {
    return {
      selected: ''
    }
  },
  methods: {
    update() {
      const isAiDocument = (/^(true|1)$/i).test(this.selected) && !!this.selected
      this.setSubFolderParams({
        isAiDocument: isAiDocument
      })
    }
  },
  created() {
    this.selected = this.stateFolder.subFolderParams.isAiDocument.toString()
  }
}
</script>

<style scoped lang="scss">
.custom-color-gray {
  color: #575757;
}
.custom-title {
  font-size: 1.5rem;
}
.custom-legend {
  font-size: 1.125rem;
}
.custom-label {
  font-size: 1.25rem;
  line-height: 1;
  color: #000;
}
.radio-legend {
  margin-left: calc(24px + 1rem);
  line-height: 1;
}
</style>
